import React, { useState, useEffect } from "react";
import { useFeatures } from "./hooks/usePermissions";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate } from "react-router-dom";
import { BlobServiceClient } from "@azure/storage-blob";
import CryptoJS from "crypto-js";
import { MultiSelect } from "primereact/multiselect";
import { DatePicker } from "antd";
import { BiSolidCalendar } from "react-icons/bi";
import dayjs from "dayjs";
import AADHeader from "./components/AADHeader.js";
import { data } from "jquery";
import WestIcon from "@mui/icons-material/West";
import EastIcon from "@mui/icons-material/East";
import Repository from "./Repository.js";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import usePermissions from "./hooks/usePermissions";
import { PERMISSIONS } from "./constants/permissions";
import PermissionTooltip from "./components/PermissionTooltip";

const steps = ["Start", "Materiality", "Module", "Input", "Report"];

export default function Csrd() {
  const username = localStorage.getItem("userName");
  const companyid = localStorage.getItem("companyid");
  const { has: hasPermission } = usePermissions();
  const canStartAssessment = hasPermission(PERMISSIONS.START_ASSESSMENTS);
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
  const [loading, setLoading] = useState(false);
  const [savedReports, setSavedReports] = useState([]);
  const [formData, setFormData] = useState({
    reportName: "",
    completionTimeline: "",
    legalEntity: "",
    startDate: "",
    endDate: "",
  });
  const [selectedDate, setSelectedDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startDate1, setStartDate1] = useState(null);
  const [endDate1, setEndDate1] = useState(null);
  const [isToDateEnabled, setIsToDateEnabled] = useState(false);
  const [minToDate, setMinToDate] = useState(null);
  const [name, setName] = useState("");
  const [timeline, setTimeline] = useState("");
  const [timeline1, setTimeline1] = useState("");
  const [legalEntity, setLegalEntity] = useState("");
  const [activelegalentity, setActiveLegalEntity] = useState("");
  const [errors, setErrors] = useState({});
  const [tags, setTags] = useState([]);
  const [input, setInput] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [existingReportNames, setExistingReportNames] = useState([]);
  const organization = localStorage.getItem("organization");
  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    if (isCsrdOnly) {
      // const organization = localStorage.getItem("organization"); // Get organization from localStorage
      // if (organization) {
      //   const orgArray = organization.split(",").map((item) => item.trim()); // Convert to array
      //   setTags(orgArray); // Set as default tags
      //   setLegalEntity(orgArray.join(", ")); // Keep `legalEntity` in sync
      // }
      const organization = localStorage.getItem("companyName"); // Get organization from localStorage
      if (organization) {
        const orgArray = organization.split(",").map((item) => item.trim()); // Convert to array
        setTags(orgArray); // Set as default tags
        setLegalEntity(orgArray.join(", ")); // Keep `legalEntity` in sync
      }
    }
  }, []); // Runs only on component mount

  const handleKeyDown = (e) => {
    if ((e.key === "Enter" || e.key === ",") && input.trim()) {
      e.preventDefault();
      if (!tags.includes(input.trim())) {
        const newTags = [...tags, input.trim()];
        setTags(newTags);
        setLegalEntity(newTags.join(", "));
      }
      setInput("");
    }
  };

  const handleRemoveTag = (tagToRemove) => {
    if (isCsrdOnly) {
      // For CSRD, remove from the tags array and update legalEntity as a comma-separated string.
      const updatedTags = tags.filter((tag) => tag !== tagToRemove);
      setTags(updatedTags);
      setLegalEntity(updatedTags.join(", "));
    } else {
      // For non-CSRD, assume legalEntity is an array and update it directly.
      const updatedLegalEntity = legalEntity.filter((tag) => tag !== tagToRemove);
      setLegalEntity(updatedLegalEntity);
    }
  };

  useEffect(() => {
    const step1 = localStorage.getItem("step1");
    if (step1 === undefined || step1 === null) {
      console.log("Step1 is empty");
    } else {
      const dataStep1 = JSON.parse(step1);
      setName(dataStep1.name);
      if (dataStep1.timeline1 !== "") {
        setTimeline(dayjs(dataStep1.timeline1));
        setSelectedDate(dayjs(dataStep1.timeline1)); // Convert to dayjs object
      }
      setLegalEntity(dataStep1.legalEntity);
      if (dataStep1.startDate1 !== null) {
        setStartDate(dayjs(dataStep1.startDate1));
      }
      if (dataStep1.endDate1 !== null) {
        setEndDate(dayjs(dataStep1.endDate1));
      }
    }
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false); // Close sidebar on mobile
      } else {
        setIsSidebarOpen(true); // Open sidebar on larger screens
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  var myHeaders = new Headers();
  myHeaders.append("username", username);

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  const handleFormChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  async function fetchLegalEntity() {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}list-entities`, requestOptions);
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success == false) {
          setActiveLegalEntity("");
        } else if (responseJson.status == 400) {
          setActiveLegalEntity("");
        } else {
          setActiveLegalEntity(responseJson.data.filter((item) => item.isActive === true));
        }
      } else {
        setActiveLegalEntity("");
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchExistingReportNames() {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}allreports`, {
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          companyid: companyid,
          username: username,
        },
      });
      if (response.status !== 200) {
        setExistingReportNames([]);
        return;
      }
      const responseJson = await response.json();
      if (responseJson?.success === false || responseJson?.status === 400 || !Array.isArray(responseJson?.data)) {
        setExistingReportNames([]);
        return;
      }
      const names = responseJson.data.map((item) => (item?.reportTitle || "").toString()).filter(Boolean);
      setExistingReportNames(names);
    } catch (error) {
      console.error(error);
      setExistingReportNames([]);
    }
  }

  const isDuplicateReportName = (reportName) => {
    const normalizedName = (reportName || "").trim().toLowerCase();
    if (!normalizedName) return false;
    return existingReportNames.some((existingName) => (existingName || "").trim().toLowerCase() === normalizedName);
  };

  // Legacy "CSRD-only" mode: reports without dashboards or company structure.
  const { isCsrdOnly } = useFeatures();

  const handleCheckboxChange = (label, checked) => {
    const updatedCheckboxes = checked ? [...formData.selectedCheckboxes, label] : formData.selectedCheckboxes.filter((item) => item !== label);

    setFormData({
      ...formData,
      selectedCheckboxes: updatedCheckboxes,
    });
  };

  const formatDate = (date) => {
    return date ? date.toLocaleDateString() : "";
  };

  async function uploadJsonFile(containerName, folderName, fileName, jsonData) {
    try {
      // Fetch SAS token from your API
      let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}GetSASToken`, {
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      });

      if (res.status === 200) {
        const responseJson = await res.json();
        const connectionString = responseJson.data;

        // Create BlobServiceClient using the SAS token
        const blobServiceClient = new BlobServiceClient(connectionString);

        // Get or create container
        const containerClient = blobServiceClient.getContainerClient(containerName);

        //await containerClient.createIfNotExists();

        // Get BlobClient for the file
        const blobName = `${folderName}/${fileName}.json`; // Construct blob name with folder path
        const blobClient = containerClient.getBlobClient(blobName);
        const blockBlobClient = blobClient.getBlockBlobClient();
        console.log(blobClient);
        // Convert JSON data to ArrayBuffer
        const arrayBuffer = new TextEncoder().encode(JSON.stringify(jsonData));

        // Upload the file content
        const uploadResponse = await blockBlobClient.uploadBrowserData(arrayBuffer.buffer, {
          blobHTTPHeaders: { blobContentType: "application/json" }, // Set content type as JSON
          blockSize: 4 * 1024 * 1024, // 4MB block size
          concurrency: 20, // Number of concurrent requests
          onProgress: (ev) => console.log(ev.loadedBytes),
        });
        if (uploadResponse) {
          console.log(`JSON file "${fileName}" uploaded successfully.`);
          console.log(`Blob URL: ${blobClient.url}`);
          localStorage.setItem("hash", fileName);
          localStorage.setItem("bloburl", blobClient.url);
          const timelineDate = timeline.toDate();
          const startDateObj = startDate.toDate();
          const endDateObj = endDate.toDate();
          const year = timelineDate.getFullYear();
          const month = String(timelineDate.getMonth() + 1).padStart(2, "0");
          const day = String(timelineDate.getDate()).padStart(2, "0");
          const formattedTimeline = `${year}-${month}-${day}`;

          const yearstartDate = startDateObj.getFullYear();
          const monthstartDate = String(startDateObj.getMonth() + 1).padStart(2, "0");
          const daystartDate = String(startDateObj.getDate()).padStart(2, "0");
          const formattedstartDate = `${yearstartDate}-${monthstartDate}-${daystartDate}`;

          const yearendDate = endDateObj.getFullYear();
          const monthendDate = String(endDateObj.getMonth() + 1).padStart(2, "0");
          const dayendDate = String(endDateObj.getDate()).padStart(2, "0");
          const formattedendDate = `${yearendDate}-${monthendDate}-${dayendDate}`;
          const organizationValue = localStorage.getItem("organization");
          const bloburl = localStorage.getItem("bloburl");
          const username = localStorage.getItem("userName");
          const hash = localStorage.getItem("hash");
          const requestOptions = {
            reportId: hash,
            reportTitle: name,
            companyName: organizationValue,
            companyId: companyid,
            blobStorageLocation: bloburl,
            updatedBy: username,
            reportStatus: "Active",
            updateComment: "Test Comment",
            completionTimeline: formattedTimeline,
            reportingPeriod: formattedstartDate + " to " + formattedendDate,
            type: "CSRD",
          };
          const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}save-report`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              username: localStorage.getItem("userName"),
            },
            body: JSON.stringify(requestOptions),
          });
          const data = await response.json();
          if (data.success == false) {
          } else if (data.status == 400) {
          } else {
          }
        }

        // Perform any additional operations after successful upload
        // uploadFileName(fileName); // Assuming this is some function you want to call after upload
      } else {
        console.error("Failed to fetch SAS token.");
      }
    } catch (error) {
      console.error("Error uploading JSON file:", error);
    }
  }

  const validateForm = () => {
    let formErrors = {};
    if (!name) formErrors.reportName = "Report Name is required";
    if ((name || "").trim() && isDuplicateReportName(name)) {
      formErrors.reportName = "Report name already exists. Please enter a unique report name.";
    }
    if (!timeline) formErrors.completionTimeline = "Completion Timeline is required";
    if (!legalEntity || legalEntity.length === 0) {
      formErrors.legalEntity = "Legal Entity is required";
    }
    if (!startDate) formErrors.startDate = "Start Date is required";
    if (!endDate) formErrors.endDate = "End Date is required";
    console.log(formErrors);
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };
  const handleBeforeAdd = () => {
    if (validateForm()) return true;
    setTimeout(() => {
      const firstInvalid = document.querySelector(".csrd-form .is-invalid");
      if (firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 50);
    return false;
  };

  const handleSave = async () => {
    console.log("Hello");
    if (!validateForm()) return;
    console.log("Hello 1");
    console.log("timeline before save:", timeline);
    console.log("timeline before save:", timeline1);

    const reportingPeriod = {
      startDate: startDate,
      endDate: endDate,
    };

    const completionTimeline = selectedDate || null;

    const newReport = {
      reportName: formData.reportName,
      framework: "CSRD",
      status: "In Progress",
      completionTimeline: completionTimeline,
      reportingPeriod: reportingPeriod,
      creator: "Unknown",
      checkboxes: formData.selectedCheckboxes,
    };

    const existingReports = JSON.parse(localStorage.getItem("savedReports")) || [];
    const updatedReports = [...existingReports, newReport];
    localStorage.setItem("savedReports", JSON.stringify(updatedReports));

    // Convert Day.js objects to native Date objects
    const timelineDate = timeline.toDate();
    const startDateObj = startDate.toDate();
    const endDateObj = endDate.toDate();
    if (timelineDate instanceof Date && startDateObj instanceof Date && endDateObj instanceof Date) {
      const year = timelineDate.getFullYear();
      const month = String(timelineDate.getMonth() + 1).padStart(2, "0");
      const day = String(timelineDate.getDate()).padStart(2, "0");
      const formattedTimeline = `${year}-${month}-${day}`;

      const yearstartDate = startDateObj.getFullYear();
      const monthstartDate = String(startDateObj.getMonth() + 1).padStart(2, "0");
      const daystartDate = String(startDateObj.getDate()).padStart(2, "0");
      const formattedstartDate = `${yearstartDate}-${monthstartDate}-${daystartDate}`;

      const yearendDate = endDateObj.getFullYear();
      const monthendDate = String(endDateObj.getMonth() + 1).padStart(2, "0");
      const dayendDate = String(endDateObj.getDate()).padStart(2, "0");
      const formattedendDate = `${yearendDate}-${monthendDate}-${dayendDate}`;
      // const step1 = localStorage.getItem("step1");
      // if(step1 === undefined || step1 === null){
      //   console.log("Step1 is empty");
      // }
      // else{

      // }
      const rdata = {
        name: name,
        timeline: formattedTimeline,
        timeline1: selectedDate,
        legalEntity: legalEntity,
        startDate: formattedstartDate,
        startDate1: startDateObj,
        endDate: formattedendDate,
        endDate1: endDateObj,
      };
      console.log(rdata);
      const reportName = companyid + "_" + name + "_" + legalEntity + "_" + formattedTimeline;
      const hash = CryptoJS.MD5(reportName).toString();
      uploadJsonFile("ecoprismfilecontainer", companyid, hash, rdata);
      localStorage.setItem("step1", JSON.stringify(rdata));
      setSavedReports(updatedReports);

      setFormData({
        reportName: "",
        completionTimeline: "",
        legalEntity: "",
        reportingPeriod: "",
        selectedCheckboxes: [],
      });

      setSelectedDate(null);
      setStartDate(null);
      setEndDate(null);

      // Log data before navigating
      console.log("Data being saved:", newReport);

      navigate("/materiality");
    } else {
      console.error("One or more dates are not valid Date objects:", timeline, startDate, endDate);
    }
  };

  const handleMultiSelectChange = (selectedValues) => {
    setLegalEntity(Array.isArray(selectedValues) ? selectedValues : []);
  };

  const handleDateChange = (date, setter) => {
    console.log(date);
    if (!date) {
      return; // Exit early if date is null or undefined
    }
    if (setter === setStartDate) {
      if (endDate && date > endDate) {
        setEndDate(null);
      }
      setStartDate(date);
      setStartDate1(date);
      setIsToDateEnabled(true);
      setMinToDate(date);
    } else if (setter === setEndDate) {
      setEndDate(date);
      setEndDate1(date);
    } else if (setter === setSelectedDate) {
      setSelectedDate(date);
      setTimeline(date); // Ensure timeline is set as a Date object
      setTimeline1(date);
      setFormData({
        ...formData,
        completionTimeline: date,
      });
    } else {
      setter(date);
    }
  };

  useEffect(() => {
    fetchLegalEntity();
    fetchExistingReportNames();
    localStorage.setItem("popup1", "true");
    localStorage.setItem("popup2", "true");
    localStorage.setItem("popup3", "true");
  }, []);

  const legalentity = activelegalentity && activelegalentity.map((status) => status.name);

  const renderHeader = () => {
    const loginType = localStorage.getItem("loginType");
    if (loginType === "AAD") {
      return <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
    }
    return <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
  };

  return (
    <div id="wrapper">
      <div>
        {loading && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </div>
      {renderHeader()}
      <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div id="page-content-wrapper" className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}>
        <div className="container formpd">
          <div className="">
            <div className="row">
              <div className="steps__containt-hader col-md-6">
                <h1 className="title">CSRD</h1>
                <div role="presentation">
                  <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                    <Link underline="hover" color="inherit" href="/standards">
                      Reports
                    </Link>
                    <Link underline="hover" color="inherit" href="/standards">
                      Standards & Frameworks
                    </Link>
                    <Typography color="text.primary">CSRD</Typography>
                  </Breadcrumbs>
                </div>
              </div>
              <div className="stepper-box col-md-6">
                <Stepper activeStep={0} alternativeLabel className="csrd-stepper">
                  {steps.map((label) => (
                    <Step key={label}>
                      <StepLabel className="step-name">{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </div>
            </div>
          </div>
          <div>
            <div className="row csrd-top">
              <div className="csrd-text col-md-12">
                <div className="row csrd-row-equal-height">
                  <div className="col-md-2 csrd-image-col">
                    <div className="csrd-image-container">
                      <img src="./assets/img/reports/csrd.png" alt="CSRD" className="csrd-image" />
                    </div>
                  </div>
                  <div className="col-md-10 csrd-text-col">
                    <h2>Corporate Sustainability Reporting Directive</h2>
                    <p>
                      The Corporate Sustainability Reporting Directive (CSRD) requires companies to report on the impact of corporate activities on the environment and society and requires the audit (assurance) of reported information.​
                      <a href="https://finance.ec.europa.eu/capital-markets-union-and-financial-markets/company-reporting-and-auditing/company-reporting/corporate-sustainability-reporting_en" target="_blank">
                        &lt;Read More&gt;
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-3">
                <div className="repository-box">
                  <a href="/repository" target="_blank">
                    <img src="./assets/img/reports/repository.svg" alt="CSRD" />
                  </a>
                  <a href="/repository" target="_blank">
                    <p>
                      Upload your files to let our AI bot simplify your CSRD reporting!
                    </p>
                  </a>
                  <Link to="/repository" target="_blank" rel="noopener noreferrer">
                    <p>Upload your files to let our AI bot simplify your CSRD reporting!</p>
                  </Link>
                </div>
              </div> */}
            </div>
            <div className="row mt-4">
              <div className="button-box d-flex justify-content-end">
                <Button
                  onClick={() => {
                    const step1 = localStorage.getItem("step1");
                    if (!step1 || step1 === "null" || step1 === "undefined") {
                      setOpenDialog(true);
                      return;
                    }
                    navigate("/materiality");
                  }}
                  variant="outlined"
                  className="module-btn"
                  size="medium"
                >
                  Materiality <EastIcon fontSize="small" sx={{ marginLeft: "4px" }} />
                </Button>
              </div>
            </div>

            <div className="csrd-form">
              <form>
                <h2>New Report</h2>
                <div className="row gx-5 gy-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="formlable" htmlFor="reportName">
                        Report Name <span className="mark-form">*</span>
                      </label>
                      <input
                        type="text"
                        required
                        className={`form-control ${errors.reportName ? "is-invalid" : ""}`}
                        name="reportName"
                        placeholder="Enter the required report name"
                        value={name}
                        onChange={(e) => {
                          const input = e.target.value;

                          if (input.length <= 30) {
                            setName(input);
                            localStorage.setItem("report_name", input);
                            if ((input || "").trim() && isDuplicateReportName(input)) {
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                reportName: "Report name already exists. Please enter a unique report name.",
                              }));
                            } else {
                              setErrors((prevErrors) => ({ ...prevErrors, reportName: "" }));
                            }
                          } else {
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              reportName: "Report name cannot exceed 30 characters",
                            }));
                          }
                        }}
                      />

                      {errors.reportName && <div className="invalid-feedback">{errors.reportName}</div>}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="formlable" htmlFor="completionTimeline">
                        Completion Timeline <span className="mark-form">*</span>
                      </label>
                      <div className="custom-date-picker date-picker">
                        <DatePicker
                          id="completionTimeline"
                          value={selectedDate}
                          onChange={(date) => {
                            handleDateChange(date, setSelectedDate);
                            setErrors((prevErrors) => ({ ...prevErrors, completionTimeline: "" }));
                          }}
                          className={`calendar-form form-control ${errors.completionTimeline ? "is-invalid" : ""}`}
                          placeholder="Select Date"
                          format="YYYY-MM-DD"
                          disabledDate={(current) => current && current < new Date(new Date().setHours(0, 0, 0, 0))}
                          allowClear
                          suffixIcon={<BiSolidCalendar />}
                        />
                        {errors.completionTimeline && <div className="invalid-feedback">{errors.completionTimeline}</div>}
                      </div>
                    </div>
                  </div>
                </div>

                <h2>Specify the reporting boundary</h2>
                <div className="row gx-5 gy-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="formlable" htmlFor="legalEntity">
                        Legal Entity <span className="mark-form">*</span>
                      </label>
                      {isCsrdOnly ? (
                        <div>
                          <div className="tag-input-container">
                            <div className="tag-input">
                              {tags.map((tag, index) => (
                                <span key={index} className="tag">
                                  {tag}
                                  <button onClick={() => handleRemoveTag(tag)} className="remove-btn">
                                    ×
                                  </button>
                                </span>
                              ))}
                              <input type="text" id="legalEntity" name="legalEntity" value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={handleKeyDown} placeholder="Type and press Enter" className="input-field" />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div>
                          {/* MultiSelect Input - Show only the count */}
                          <MultiSelect
                            id="legalEntity"
                            name="legalEntity"
                            className={`wd-100 custom-multiselect ${errors.legalEntity ? "is-invalid" : ""}`}
                            value={legalEntity}
                            onChange={(e) => {
                              handleMultiSelectChange(e.value);
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                legalEntity: "", // Clear error when an item is selected
                              }));
                            }}
                            options={legalentity}
                            placeholder={legalEntity.length > 0 ? `${legalEntity.length} items selected` : "Select legal entity"}
                            maxSelectedLabels={0} // Hide selected names in the dropdown box
                            showClear={false}
                            showSelectAll={true}
                            selectAllLabel="Select All"
                            style={{ "--placeholder-font-size": "16px", height: "40px" }}
                          />

                          {errors.legalEntity && <div className="invalid-feedback">{errors.legalEntity}</div>}

                          {/* Display selected legal entities as tags outside the input */}
                          <div className="selected-tags-container">
                            {Array.isArray(legalEntity) &&
                              legalEntity.map((entity, index) => (
                                <span key={index} className="tag">
                                  {entity}
                                  <button onClick={() => handleRemoveTag(entity)} className="remove-btn">
                                    ×
                                  </button>
                                </span>
                              ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="formlable" htmlFor="reportingPeriod">
                        Reporting Period <span className="mark-form">*</span>
                      </label>
                      <div className="row gx-2">
                        <div className="col-md-6">
                          <div className="custom-start-date-picker date-picker">
                            <DatePicker
                              id="startDate"
                              value={startDate}
                              onChange={(date) => {
                                handleDateChange(date, setStartDate);
                                setErrors((prevErrors) => ({ ...prevErrors, startDate: "" }));
                              }}
                              className={`calendar-form form-control ${errors.startDate ? "is-invalid" : ""}`}
                              placeholder="Start Date"
                              suffixIcon={<BiSolidCalendar />}
                            />
                            {errors.startDate && <div className="invalid-feedback">{errors.startDate}</div>}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="custom-end-date-picker date-picker">
                            <DatePicker
                              id="endDate"
                              value={endDate}
                              onChange={(date) => {
                                handleDateChange(date, setEndDate);
                                setErrors((prevErrors) => ({ ...prevErrors, endDate: "" }));
                              }}
                              className={`calendar-form form-control ${errors.endDate ? "is-invalid" : ""}`}
                              placeholder="End Date"
                              disabled={!isToDateEnabled}
                              showToday={false}
                              format={"YYYY-MM-DD"}
                              suffixIcon={<BiSolidCalendar />}
                              disabledDate={
                                (current) => current && current < startDate // Disable dates before startDate
                              }
                            />
                            {errors.endDate && <div className="invalid-feedback">{errors.endDate}</div>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <h2>Repository of Documents</h2>
                <p>These documents will be used by our AI bot to prepare answers for qualitative disclosures.</p>
                <Repository
                  isEmbedded={true}
                  reportName={name}
                  onBeforeAdd={handleBeforeAdd}
                />
                <div className="row justify-content-end pt-3">
                  <div className="col-auto">
                    <Button href="standards" variant="outlined" className="outline-btn" size="medium" type="button">
                      Cancel
                    </Button>
                  </div>
                  <div className="col-auto">
                    <PermissionTooltip disabled={!canStartAssessment} reason="You don't have permission to create a report">
                    <Button onClick={handleSave} disabled={!canStartAssessment} className="next-button" variant="contained" size="medium">
                      Save
                    </Button>
                    </PermissionTooltip>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Dialog for form validation warning */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: "16px",
            padding: "20px",
            minWidth: "400px",
            textAlign: "center",
          },
        }}
      >
        <DialogContent sx={{ paddingTop: "20px", paddingBottom: "10px" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <img src="assets/img/error.png" alt="Error" style={{ width: "55px", height: "55px" }} />
            <Typography variant="h5" component="div" sx={{ fontWeight: 600, color: "#407775" }}>
              Error!
            </Typography>
            <DialogContentText
              id="alert-dialog-description"
              sx={{
                fontSize: "16px",
                color: "#666",
                marginBottom: "10px",
              }}
            >
              Please fill in and save the form before proceeding to Materiality.
            </DialogContentText>
          </div>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", paddingBottom: "20px" }}>
          <Button
            onClick={() => setOpenDialog(false)}
            variant="contained"
            autoFocus
            sx={{
              backgroundColor: "#407775",
              color: "white",
              padding: "10px 40px",
              fontSize: "16px",
              fontFamily: "Poppins, sans-serif",
              textTransform: "none",
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "#356663",
              },
            }}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
